const polish = new Intl.PluralRules('pl');

/**
 * Picks the form of a counted word by Polish rules: `one` for 1, `few` for
 * 2–4 (22–24, …), `many` for the rest. English only tells one from the rest,
 * so an English dictionary passes its plural as both `few` and `many`.
 */
export function plural(
  n: number,
  one: string,
  few: string,
  many: string,
): string {
  switch (polish.select(n)) {
    case 'one':
      return one;
    case 'few':
      return few;
    default:
      return many;
  }
}
